// Helper deret data chart. Sengaja NOL IMPORT biar bisa dijalanin langsung pakai node.

// Isi lubang null di antara dua angka pakai interpolasi linear. Null di ujung
// (sebelum angka pertama / sesudah angka terakhir) dibiarin null.
export function interpolateNulls(dataArray) {
  const result = [...dataArray];
  for (let i = 0; i < result.length; i++) {
    if (result[i] === null) {
      const startIndex = i - 1;
      const startValue = startIndex >= 0 ? result[startIndex] : null;

      if (startValue !== null) {
        let endIndex = -1;
        for (let j = i + 1; j < result.length; j++) {
          if (result[j] !== null) {
            endIndex = j;
            break;
          }
        }

        if (endIndex !== -1) {
          const endValue = result[endIndex];
          const gapCount = endIndex - startIndex;
          const step = (Number(endValue) - Number(startValue)) / gapCount;

          for (let k = startIndex + 1; k < endIndex; k++) {
            const interpolatedValue = Number(startValue) + step * (k - startIndex);
            result[k] = Number(interpolatedValue.toFixed(2));
          }
          i = endIndex - 1;
        }
      }
    }
  }
  return result;
}

export default { interpolateNulls };
